/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Feature_Interview_PrepInputs */

const en_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep`)
};

const de_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorstellungsgespräch-Vorbereitung`)
};

const fr_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préparation d'entretien`)
};

const es_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparación de entrevista`)
};

const it_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparazione colloqui`)
};

const nl_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatievoorbereiding`)
};

const pl_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy kwalifikacyjnej`)
};

const fi_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelun valmistelu`)
};

const da_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse`)
};

const sv_settings_feature_interview_prep = /** @type {(inputs: Settings_Feature_Interview_PrepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervju förberedelse`)
};

/**
* | output |
* | --- |
* | "Interview prep" |
*
* @param {Settings_Feature_Interview_PrepInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_feature_interview_prep = /** @type {((inputs?: Settings_Feature_Interview_PrepInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Feature_Interview_PrepInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_feature_interview_prep(inputs)
	if (locale === "fr") return fr_settings_feature_interview_prep(inputs)
	if (locale === "es") return es_settings_feature_interview_prep(inputs)
	if (locale === "it") return it_settings_feature_interview_prep(inputs)
	if (locale === "nl") return nl_settings_feature_interview_prep(inputs)
	if (locale === "pl") return pl_settings_feature_interview_prep(inputs)
	if (locale === "fi") return fi_settings_feature_interview_prep(inputs)
	if (locale === "da") return da_settings_feature_interview_prep(inputs)
	if (locale === "sv") return sv_settings_feature_interview_prep(inputs)
	return en_settings_feature_interview_prep(inputs)
});